import React from 'react';

const Topics: React.FC = () => (
  <section id="topics">
    <div className="topics-inner">
      <div className="topics-side reveal">
        <p className="eyebrow">Topics</p>
        <h2 className="topics-h2">
          Over 1,000,000 Muslims asked us their hardest questions on MuslimGPT.{' '}
          <em>We turned the answers into lessons.</em>
        </h2>
        <p className="topics-sub">
          The topics in Niyyah didn&apos;t come from a curriculum. They came from six months of real Muslims wrestling with real life.
        </p>
      </div>
      <div className="topics-grid">
        <div className="topic-tile tt-coral reveal reveal-delay-1">
          <div className="topic-tile-icon">❤️</div>
          <h4>Marriage &amp; Relationships</h4>
        </div>
        <div className="topic-tile tt-teal reveal reveal-delay-2">
          <div className="topic-tile-icon">💰</div>
          <h4>Money &amp; Finance</h4>
        </div>
        <div className="topic-tile tt-purple reveal reveal-delay-3">
          <div className="topic-tile-icon">🌿</div>
          <h4>Anxiety &amp; Inner Peace</h4>
        </div>
        <div className="topic-tile tt-orange reveal reveal-delay-4">
          <div className="topic-tile-icon">🕌</div>
          <h4>Prayer &amp; Worship</h4>
        </div>
      </div>
    </div>
  </section>
);

export default Topics;
